export const MONITOR_REFRESH_INTERVAL_MS = 10 * 60_000
